const validZipCodeCharacterRegex = new RegExp(/[a-zA-Z0-9\\-]+/);
export const extractValidZipCodeAndCalculateCursorPosition = (value, cursorPosition) => {
    const { validZipCode, cursorPositionBump } = value
        .split('')
        .reduce((prev, curr, index) => {
        const isValidZipCodeCharacter = validZipCodeCharacterRegex.test(curr);
        if (isValidZipCodeCharacter) {
            prev.validZipCode = prev.validZipCode + curr;
            return prev;
        }
        const isSpace = / /.test(curr);
        if (!isSpace)
            return prev;
        const spaceIsAtStart = prev.validZipCode.length === 0;
        if (spaceIsAtStart)
            return prev;
        const spaceCursorPosition = index + 1;
        const lastMatchedSpacePosition = prev.lastMatchedSpacePosition;
        const noSpaceIsInserted = lastMatchedSpacePosition === null;
        if (noSpaceIsInserted) {
            prev.validZipCode = prev.validZipCode + curr;
            prev.lastMatchedSpacePosition = spaceCursorPosition;
            return prev;
        }
        const noInformationAboutCursor = cursorPosition === null;
        if (noInformationAboutCursor)
            return prev;
        // New space is inserted after already added space
        if (cursorPosition > lastMatchedSpacePosition) {
            // Remove previous space
            prev.validZipCode = prev.validZipCode.replace(curr, '');
            // Add new space
            prev.validZipCode = prev.validZipCode + curr;
            prev.lastMatchedSpacePosition = spaceCursorPosition;
            prev.cursorPositionBump = 0;
            return prev;
        }
        // Space is inserted before already added space
        prev.cursorPositionBump = -1;
        return prev;
    }, {
        validZipCode: '',
        lastMatchedSpacePosition: null,
        cursorPositionBump: 0,
    });
    const difference = value.length - validZipCode.length + cursorPositionBump;
    const newCursorPosition = cursorPosition ? cursorPosition - difference : null;
    return { validZipCode, newCursorPosition };
};
